import { render, staticRenderFns } from "./h5homepage.vue?vue&type=template&id=2731dcf3"
import script from "./h5homepage.vue?vue&type=script&lang=js"
export * from "./h5homepage.vue?vue&type=script&lang=js"
import style0 from "./h5homepage.vue?vue&type=style&index=0&id=2731dcf3&prod&lang=less"
import style1 from "./h5homepage.vue?vue&type=style&index=1&id=2731dcf3&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports